import { SelectedOrgChecker } from '@features/organisations/components/SelectedOrgChecker'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  AUTOMATION_ORDER_BY_FIELDS,
  DEFAULT_DATA_EVENT_ORDER,
  listAutomationsRequestSchema,
} from '@customTypes/cloudmix/automations'
import { withListHydration } from '@lib/listState/withListHydration'
import { DataEventAutomationsList } from '@features/automations/components/DataEventAutomationsList'

const DataEventAutomationsRoute = () => (
  <SelectedOrgChecker>
    <DataEventAutomationsList />
  </SelectedOrgChecker>
)

const routerSchema = listAutomationsRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/automations/dataEvents')({
  component: DataEventAutomationsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      defaultSort: [DEFAULT_DATA_EVENT_ORDER],
      allowedOrderByFields: AUTOMATION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Data Event Automations',
  }),
  loader: () => ({
    crumb: 'Data Events',
  }),
})
